import { collection, getDocs, deleteDoc, query, limit } from "firebase/firestore";

const RETENTION_MS = 45 * 86400 * 1000;
const MAX_DELETES_PER_RUN = 300;

export default async function cleanupOldTracks(db, entries) {
  if (!db || !Array.isArray(entries)) return 0;
  const cutoff = Date.now() - RETENTION_MS;
  const oldEntries = entries.filter((e) => {
    const t = e.clockOut ? new Date(e.clockOut).getTime() : new Date(e.clockIn).getTime();
    return t < cutoff;
  });
  if (!oldEntries.length) return 0;

  let deleted = 0;
  for (const entry of oldEntries) {
    if (deleted >= MAX_DELETES_PER_RUN) break;
    try {
      const trackQ = query(
        collection(db, "timeEntries", entry.id, "track"),
        limit(MAX_DELETES_PER_RUN - deleted)
      );
      const snap = await getDocs(trackQ);
      if (snap.empty) continue;
      await Promise.all(snap.docs.map((d) => deleteDoc(d.ref)));
      deleted += snap.size;
    } catch (e) {
      console.warn("[cleanupOldTracks] failed for entry", entry.id, e?.message);
    }
  }
  if (deleted > 0) console.log(`[cleanupOldTracks] deleted ${deleted} expired GPS points`);
  return deleted;
}
